import Thumbnail1 from "../../public/assets/images/portfolio/Thumbnail-1.png";
import Thumbnail2 from "../../public/assets/images/portfolio/Thumbnail-2.png";
import Thumbnail4 from "../../public/assets/images/portfolio/Thumbnail-4.png";
import Thumbnail5 from "../../public/assets/images/portfolio/Thumbnail-5.png";
import Thumbnail6 from "../../public/assets/images/portfolio/Thumbnail-6.png";
import Thumbnail7 from "../../public/assets/images/portfolio/Thumbnail-7.png";
import Thumbnail8 from "../../public/assets/images/portfolio/Thumbnail-8.png";
import Thumbnail9 from "../../public/assets/images/portfolio/Thumbnail-9.png";
import Thumbnail10 from "../../public/assets/images/portfolio/Thumbnail-10.png";
import Thumbnail11 from "../../public/assets/images/portfolio/Thumbnail-11.png";
import Thumbnail12 from "../../public/assets/images/portfolio/Thumbnail-12.png";
import Thumbnail13 from "../../public/assets/images/portfolio/Thumbnail-13.png";
import Thumbnail14 from "../../public/assets/images/portfolio/Thumbnail-14.png";
import Thumbnail15 from "../../public/assets/images/portfolio/Thumbnail-15.png";
import Thumbnail from "../../public/assets/images/portfolio/Thumbnail.png";

export {
  Thumbnail1,
  Thumbnail2,
  Thumbnail4,
  Thumbnail5,
  Thumbnail6,
  Thumbnail7,
  Thumbnail8,
  Thumbnail9,
  Thumbnail10,
  Thumbnail11,
  Thumbnail12,
  Thumbnail13,
  Thumbnail14,
  Thumbnail15,
  Thumbnail,
};
